module.exports = __webpack_public_path__ + "img/Arrow-Right.7bfa13cc.svg";